import type {
  DecoratedUnisonProjectScanService,
  UndecoratedScanService,
} from '@witmetrics/utils';
import { SCAN_SERVICE_STATUS } from '@witmetrics/utils/constants';
import {
  filterOutKeyValue,
  mapToId,
  mapToKey,
  sortByUpdatedAt,
} from '@witmetrics/utils/arrays';
import { API } from '@/api';
import { PAGE_SIZE, PENDING_FILTER } from './constants';

const { IN_PROGRESS } = SCAN_SERVICE_STATUS;

export const classes = {
  // NOTE: Since toaster > default width, need a larger right offset
  toaster: 'w-[450px] right-[160px] absolute p-0',
  // Need to specify font otherwise it
  toasterContent: 'mb-0 pr-4 pl-2 font-[Inter]',
  icon: 'size-5',
};

export const styles = {
  active: {
    animationName: 'ring-notification-bell',
    animationDuration: '1.2s',
    animationTimingFunction: 'ease-in-out',
  },
  toaster: {
    fontFamily: 'Inter',
    padding: 0,
    background: 'none',
  },
  toasterBody: {
    padding: 0,
    margin: 0,
    background: 'none',
  },
};

export function sortServices(services: DecoratedUnisonProjectScanService[]) {
  return mapToId(
    sortByUpdatedAt(mapToKey(services, 'scanService')).slice(0, PAGE_SIZE)
  );
}

export async function fetchPendingServices(practiceId: number) {
  return (
    await API.Practices.fetchPracticeUnisonProjectScanServices(practiceId, {
      filters: [PENDING_FILTER],
      pagination: { page: 1, pageSize: 100 }, // TODO: Larger page size?
    })
  ).results;
}

export function getUpdatedServiceIds(services: UndecoratedScanService[]) {
  // Return all scanServices that are *not* pending
  return mapToId(filterOutKeyValue(services, 'status', IN_PROGRESS));
}
